export default __webpack_public_path__ + "static/media/movie-app.f8e1ff5b.png";